import * as React from 'react';

import { createClient, type Client } from '@connectrpc/connect';
import { ScaleLocalService } from '@rematter/frontend-lib-api-client/grpc/sidecar/v1/scale_local_api_pb';

import { useLibp2p } from './useLibp2p';

export type ScaleLocalClient = Client<typeof ScaleLocalService>;

export function useScaleLocalClient(
  sidecarId: string,
): ScaleLocalClient | null {
  const { getTransport, connections } = useLibp2p();

  const isConnected = connections.get(sidecarId)?.connected ?? false;

  return React.useMemo(() => {
    if (!isConnected) return null;

    const transport = getTransport(sidecarId);
    if (!transport) return null;

    return createClient(ScaleLocalService, transport);
  }, [sidecarId, getTransport, isConnected]);
}
